/** @jsxImportSource @emotion/react */
import React from 'react';
import paymentWaitStyles from './step-loader.styles';
import SpinnerLoader from '../../../../components/spinner-loader/spinner-loader.component';

const StepLoader = () => {
    return (
        <div css={paymentWaitStyles.infoImageContainer}>
            <div css={paymentWaitStyles.infoImageContent}>
                <SpinnerLoader />
            </div>
        </div>
    );
};

export default StepLoader;
